var CollectionView = require('views/base/collection-view');
var Block = require('models/block');
var ForgeService = require('services/forge-service');

var BlocksView = CollectionView.extend({
  animationDuration: 0,
  autoRender: true,
  noWrap: true,
  template: require('./templates/blocks'),
  initialize: function(options) {
    this.parent = options.parent;
    this.options = options;
    this.pageView = options.pageView;

    this.listenTo(this.parent, 'page:state:change', this.stateChange);
    this.listenTo(this.parent, 'block:state:completed', this.stateChange);
    if(this.collection && this.collection.head() && this.collection.head().get('order')) {
      this.parent.model.set('order', this.collection.head().get('order'));
    }
    CollectionView.prototype.initialize.apply(this, arguments);
  },
  stateChange: function(parent) {
    //proxy page state change through to child blocks
    this.trigger('page:state:change', parent);
  },
  initItemView: function(model) {
    //TODO: document this naming convention
    var BlockType = require('views/block/' + model.get('type') + '/' + model.get('type') + '-view');
    var options = {
      autoRender: false,
      script: this.options.script,
      model: model,
      parent: this,
      pageView: this.pageView
    };
    if(model.get('class')) {
      options.className = model.get('class');
    }
    // some blocks use es6 export, some dont
    if(BlockType.default) {
      BlockType = BlockType.default;
    }
    var blockView = new BlockType(options);
    this.listenTo(blockView, 'block:state:loaded', (block) => {
      ForgeService.applyForgeLink(block);
      if(this.isLoaded()) {
        this.trigger('block:state:loaded', this);
      }
    });
    this.listenTo(blockView, 'block:state:completed', function(block) {
      //proxy block state change up to parent page
      this.trigger('block:state:completed', block);
      if(this.parent.model && this.parent.model.get('order') && this.isOrderComplete()) {
        if(!(this.parent.model instanceof Block)) {
          Chaplin.mediator.publish('block:order:completed', this.parent.model.get('order'));
          Chaplin.mediator.publish(`block:order-${this.parent.model.get('order')}:completed`);
        }
        this.parent.model.set('order', this.parent.model.get('order') + 1);
        this.trigger('page:state:change', this.parent);
      }
    });

    return blockView;
  },
  isOrderComplete: function() {
    if(this.subviews) {
      var orderViews = _.filter(this.subviews, (sv) => sv.model.get('order') === this.parent.model.get('order'));
      return orderViews.length > 0 && orderViews.every((subview) => subview.isComplete());
    }
  },
  isLoaded: function() {
    if(this.subviews) {
      return _.every(this.subviews, function(subview) {
        return subview.isLoaded();
      });
    } else {
      return true;
    }
  },
  isComplete: function() {
    if(this.subviews) {
      return _.every(this.subviews, function(subview) {
        return subview.isComplete();
      });
    } else {
      return true;
    }
  }
});

module.exports = BlocksView;
